import React, { memo } from 'react';
import classNames from 'classnames';
import cls from './DocumentationBlock.module.css';
import { useDocumentationBlock } from './useDocumentationBlock';
import { DocumentDownloadBlock } from './Components/DocumentDownloadBlock/DocumentDownloadBlock';
import { ModalDocumentInfo } from '../../Modals/ModalDocumentInfo/ModalDocumentInfo';

interface DocumentationBlocksProps {
    classes?: string;
}

export const DocumentationBlock = memo(({ classes }: DocumentationBlocksProps) => {
    const {} = useDocumentationBlock();

    return (
        <div className={classNames(cls.DocumentationBlocks, [classes])}>
            <ModalDocumentInfo />
            <span className={cls.DocumentationTitle}>
                {i18next.t('DocumentationBlock.return.documentationTitle')}
            </span>
            <DocumentDownloadBlock />
        </div>
    );
});
